export default "__VITE_ASSET__DaVFN5fv__"